export default __webpack_public_path__ + "static/media/c(1).1c9ed502.jpg";